<script>
	import { model } from "../../../stores";

	import AddressAutoComplete from "../../../components/AddressAutoComplete.svelte";
	import Datepicker from "../../../components/Datepicker.svelte";
	import FormRow from "../../../components/FormRow.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";
	import PageSection from "../../../components/PageSection.svelte";

	import Declaration from "./Declaration.svelte";

	export let claimant = null;
	export let disabled = null;
</script>

<h3>Group Member Contact Details</h3>
<section>
	<FormRow>
		<FormColumn>
			<label for="claimant-email" class="isrequired">Email address of Group Member</label>
			<input
				required
				{disabled}
				type="email"
				bind:value={claimant.EmailAddress}
				id="claimant-email"
				class="form-control"
			/>
		</FormColumn>
	</FormRow>

	<AddressAutoComplete
		idPrefix="claimant"
		bind:googlePlaceJson={claimant.Address.GooglePlaceJson}
		bind:formattedAddress={claimant.Address.FormattedAddress}
		bind:premise={claimant.Address.Premise}
		bind:subpremise={claimant.Address.Subpremise}
		bind:street={claimant.Address.Street}
		bind:suburb={claimant.Address.Suburb}
		bind:state={claimant.Address.State}
		bind:postcode={claimant.Address.Postcode}
		bind:country={claimant.Address.Country}
		bind:lat={claimant.Address.Lat}
		bind:lng={claimant.Address.Lng}
		bind:placeId={claimant.Address.PlaceId}
		bind:url={claimant.Address.GoogleMapsUrl}
		{disabled}
		required
	></AddressAutoComplete>
</section>
